{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-5-biologie-pflanzen-bluetenbau-samen",
  "version": "2026.08.1",
  "title": "Biologie 5: Blütenpflanzen – Grundorgane, Blütenaufbau, Bestäubung und Samen (Realschule 5 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Biologie 5: Organe einer Samenpflanze, Zwitterblüte, Bestäubung vs. Befruchtung, Fruchtformen und Samenverbreitung.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T22:55:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/5/natur_und_technik",
      "checked": "2026-08-15",
      "label": "Realschule Natur und Technik 5 (Biologie), Lernbereich Vielfalt der Blütenpflanzen"
    }
  ],
  "atoms": [
    {
      "id": "01K4B5P0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4B5P0000000000000000A01",
      "namespace": "biologie-botanik",
      "slug": "grundorgane-bluetenpflanze-wurzel-spross-blatt",
      "title": "Die Grundorgane der Blütenpflanze: Wurzel, Sprossachse und Laubblatt",
      "domain": "schule/biologie/botanik",
      "reduction": "formal",
      "typical_age_min": 10.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q10811",
          "target_label": "Plant morphology",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 5,
          "track": "I",
          "subject": "natur_und_technik",
          "topic_code": "lb3",
          "topic_title": "Blütenpflanzen und Lebensräume",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 5,
          "track": "II_III",
          "subject": "natur_und_technik",
          "topic_code": "lb3",
          "topic_title": "Blütenpflanzen und Lebensräume",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4B5P0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Über welche mikroskopisch feinen Zellstrukturen an der Wurzelspitze nehmen Pflanzen Wasser und gelöste Mineralsalze aus dem Boden auf?",
          "concept": "Über die Wurzelhaare (Wurzelhaardichte vergrößert die Kontaktoberfläche zum Boden extrem)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Über die Wurzelhaare",
              "Über die Rinde der Hauptwurzel"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4B5P0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Beschreibe die drei vegetativen Grundorgane einer Blütenpflanze mit ihren spezialisierten Funktionen: 1. Wurzel (Verankerung im Erdreich, Aufnahme von Wasser und Mineralsalzen über Wurzelhaare, Speicherung von Reservestoffen wie bei der Rübe), 2. Sprossachse/Stängel (Stabilität, Ausrichtung der Blätter zum Sonnenlicht, Stofftransport in Leitbündeln: Wasser aufwärts im Xylem, Zuckerlösung abwärts im Phloem), 3. Laubblatt (Photosynthese mit Chlorophyll zur Stärkeherstellung, Gasaustausch und Transpiration/Verdunstung über Spaltöffnungen/Stomata).",
          "concept": "Wurzel: Verankerung + Wasser-/Nährsalzaufnahme + Speicher; Sprossachse: Stängel/Stamm trägt Blätter/Blüten, Transportröhren (Leitbündel); Laubblatt: Blattgrün (Chlorophyll) fängt Licht ein -> Fotosynthese (Wasser + CO2 -> Glukose + Sauerstoff), Spaltöffnungen regeln Transpirationssog.",
          "sample_solution": "1. Die drei Grundorgane der Blütenpflanze: - **1. Die Wurzel**:   * **Verankerung**: Hält die Pflanze fest im Boden gegen Wind und Sturm (Pfahlwurzel z. B. Löwenzahn vs. Flach-/Büschelwurzel z. B. Gräser).   * **Wasser- und Nährsalzaufnahme**: Tausende hauchdünne **Wurzelhaare** vergrößern die Saugfläche gewaltig; sie nehmen Bodenwasser mit gelösten Nährsalzen (Nitrat, Phosphat, Kalium) durch Osmose auf.   * **Speicherorgan**: Manche Pflanzen lagern Nährstoffe in verdickten Speicherwurzeln ein (z. B. Mohrrübe, Zuckerrübe). - **2. Die Sprossachse (Krautiger Stängel oder verholzter Stamm)**:   * **Stützfunktion**: Trägt Laubblätter und Blüten und richtet sie optimal zum Sonnenlicht aus.   * **Leitungsfunktion**: Enthält Leitbündel mit zwei Transportbahnen:     - *Holzteil (Xylem)*: Transportiert Wasser und Mineralstoffe von den Wurzeln nach oben in die Blätter.     - *Bastteil (Phloem)*: Transportiert die in den Blättern hergestellten Traubenzucker-Lösungen zu den Speicherorganen und Wurzeln. - **3. Das Laubblatt**:   * **Photosynthese (Zuckerfabrik der Pflanze)**: In den chloroplastenreichen Blattzellen wandelt Blattgrün (**Chlorophyll**) mit Sonnenlichtenergie Wasser und Kohlenstoffdioxid ($CO_2$) in energiereichen Traubenzucker (Glukose/Stärke) und lebenswichtigen Sauerstoff ($O_2$) um.   * **Transpiration und Gasaustausch**: Über regulierbare **Spaltöffnungen (Stomata)** auf der Blattunterseite verdunstet Wasser, wodurch ein ständiger Transpirationssog entsteht, der Wasser aus der Wurzel nach oben zieht."
        }
      ]
    },
    {
      "id": "01K4B5P0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4B5P0000000000000000A02",
      "namespace": "biologie-botanik",
      "slug": "bluetenaufbau-zwitterbluete-stempel-staubblaetter",
      "title": "Aufbau der Blüten: Kelchblätter, Kronblätter, Staubblätter (männlich) und Stempel/Fruchtblatt (weiblich)",
      "domain": "schule/biologie/botanik",
      "reduction": "formal",
      "typical_age_min": 10.5,
      "prerequisites": [
        {
          "atom_id": "01K4B5P0000000000000000A01",
          "type": "hard",
          "rationale": "Blüten sind die spezialisierten Fortpflanzungsorgane an der Sprossachse."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q10811",
          "target_label": "Flower",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 5,
          "track": "I",
          "subject": "natur_und_technik",
          "topic_code": "lb3",
          "topic_title": "Blütenpflanzen und Lebensräume",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 5,
          "track": "II_III",
          "subject": "natur_und_technik",
          "topic_code": "lb3",
          "topic_title": "Blütenpflanzen und Lebensräume",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4B5P0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Aus welchen drei Teilen besteht der weibliche Stempel (Fruchtblatt) im Zentrum einer Blütenpflanze von oben nach unten?",
          "concept": "Narbe (klebrig), Griffel und Fruchtknoten (mit den Samenanlagen)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Narbe, Griffel, Fruchtknoten",
              "Staubbeutel, Staubfaden, Pollen"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4B5P0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Beschreibe die 4 Blattkreise einer vollständigen Zwitterblüte von außen nach innen: 1. Kelchblätter (Sepalen: meist grün, schützen die Knospe), 2. Kronblätter (Petalen: farbig/duftend, locken Insekten an), 3. Staubblätter (männliche Organe: Staubfaden und Staubbeutel mit Pollensäcken/Blütenstaub), 4. Stempel / Fruchtblätter (weibliche Organe: klebrige Narbe, Griffel, Fruchtknoten mit Samenanlage und Eizelle).",
          "concept": "4 Blattkreise: 1. Kelch (Schutz Knospe), 2. Krone (Schauapparat für Bestäuber), 3. Staubblatt = Staubfaden + Staubbeutel (bildet männliche Pollenkörner), 4. Stempel = Narbe + Griffel + Fruchtknoten (enthält Samenanlage mit Eizelle).",
          "sample_solution": "1. Die 4 konzentrischen Blattkreise einer Zwitterblüte (z. B. Kirschblüte, Tulpe): - **1. Kreis: Kelchblätter (Kelch / Calyx)**:   * Meist feste, grüne Blätter ganz außen an der Blütenbasis.   * Funktion: Schützen die empfindliche Blütenknospe vor dem Aufblühen vor Kälte, Nässe und Fraßfeinden. - **2. Kreis: Kronblätter (Krone / Corolla)**:   * Häufig groß, leuchtend bunt gefärbt (Schauapparat), mit Duftdrüsen und Nektardrüsen (Nektarien) an der Basis versehen.   * Funktion: Optisches und geruchliches Signal zur Anlockung von bestäubenden Insekten (Bienen, Schmetterlinge, Hummeln). - **3. Kreis: Staubblätter (Männliche Fortpflanzungsorgane)**:   * Bestehen aus einem dünnen **Staubfaden (Filament)** und dem oben sitzenden **Staubbeutel (Anthere)**.   * Im Staubbeutel befinden sich 4 Pollensäcke, in denen Millionen mikroskopischer, gelber **Pollenkörner (Blütenstaub / männliche Keimzellen)** reifen. - **4. Kreis: Stempel / Fruchtblatt (Weibliches Fortpflanzungsorgan im Zentrum)**:   * **Narbe**: Der oberste, oft klebrige oder gefiederte Abschnitt, an dem die Pollenkörner bei der Bestäubung haften bleiben.   * **Griffel**: Schlanke Röhre, die die Narbe nach oben in die Anflugbahn der Insekten hebt.   * **Fruchtknoten**: Der verdickte Bauch an der Basis. Er birgt eine oder mehrere **Samenanlagen**, in denen jeweils eine **Eizelle** (weibliche Keimzelle) geschützt liegt."
        }
      ]
    },
    {
      "id": "01K4B5P0000000000000000A03",
      "atom_uri": "urn:zam:atom:01K4B5P0000000000000000A03",
      "namespace": "biologie-botanik",
      "slug": "bestaeubung-vs-befruchtung-insekten-windbestaeubung",
      "title": "Bestäubung versus Befruchtung: Insektenblütigkeit, Windblütigkeit und Pollenschlauchwachstum",
      "domain": "schule/biologie/botanik",
      "reduction": "formal",
      "typical_age_min": 10.5,
      "prerequisites": [
        {
          "atom_id": "01K4B5P0000000000000000A02",
          "type": "hard",
          "rationale": "Staubblätter und Narbe sind die Organe von Bestäubung und Befruchtung."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q10811",
          "target_label": "Pollination",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 5,
          "track": "I",
          "subject": "natur_und_technik",
          "topic_code": "lb3",
          "topic_title": "Blütenpflanzen und Lebensräume",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 5,
          "track": "II_III",
          "subject": "natur_und_technik",
          "topic_code": "lb3",
          "topic_title": "Blütenpflanzen und Lebensräume",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4B5P0000000000000000J05",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Was versteht man in der Botanik unter dem Begriff 'Bestäubung'?",
          "concept": "Die bloße Übertragung von Pollenkörnern vom Staubbeutel auf die klebrige Narbe",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Übertragung von Pollen auf die Narbe",
              "Verschmelzen des Pollenkerns mit der Eizelle"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4B5P0000000000000000J06",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Unterscheide biologisch präzise Bestäubung (mechanischer Transport des Blütenstaubs vom Staubbeutel auf die Narbe) von Befruchtung (Auskeimen des Pollenkorns zu einem Pollenschlauch durch den Griffel und Verschmelzen des männlichen Zellkerns mit dem Eizellkern in der Samenanlage) und vergleiche Insektenblütige (z. B. Kirsche, Rose: bunte Kronblätter, Klebriger Pollen, Nektar) mit Windblütigen Pflanzen (z. B. Hasel, Birke, Gräser: unscheinbare Kätzchen, riesige Mengen trockener Flugpollen, fedrige Narben).",
          "concept": "Bestäubung = Transportweg (Insekt/Wind) auf Narbe; Befruchtung = zelluläre Kernverschmelzung via Pollenschlauch; Insektenblütig: auffällige Farben, Duft, klebriger Pollen; Windblütig: keine Blütenpracht, Millionen staubfeiner Pollen vor Laubaustrieb, federige Fangnarben.",
          "sample_solution": "1. Biologischer Unterschied: Bestäubung vs. Befruchtung: - **Bestäubung (Der Transport)**:   * Bezeichnet ausschließlich die rein mechanische Übertragung von Pollenkörnern aus dem Staubbeutel einer Blüte auf die klebrige Narbe des Stempels (einer Blüte derselben Art).   * Kann durch Tiere (Insekten, Vögel) oder durch Wind/Wasser erfolgen. - **Befruchtung (Die zelluläre Vereinigung)**:   * Folgt erst nach erfolgreicher Bestäubung: Das Pollenkorn nimmt auf der feuchten Narbe Zuckerwasser auf, keimt aus und treibt einen **Pollenschlauch** durch das Gewebe des Griffels nach unten in den Fruchtknoten.   * In der Samenanlage dringt der Pollenschlauch zur Eizelle vor; der männliche Pollenkern verschmilzt mit dem Eizellkern zur Zygote. 2. Insektenblütige vs. Windblütige Pflanzen im Vergleich: - **Insektenblütige Pflanzen** (z. B. Obstbäume, Löwenzahn, Raps):   * Blüten: Große, intensiv gefärbte Kronblätter, auffällige Saftmale und Nektardrüsen mit zuckerhaltigem Nektar als Futterbelohnung für Bienen/Hummeln.   * Pollen: Große, klebrige, mit Widerhaken besetzte Pollenkörner, die leicht am Pelz der Insekten haften bleiben. - **Windblütige Pflanzen** (z. B. Haselstrauch, Birke, Eiche, Roggen/Gräser):   * Blüten: Unscheinbar, klein, grünlich-braun ohne Kronblätter und ohne Nektar; oft in hängenden Kätzchen angeordnet.   * Blütezeit: Oft im Vorfrühling VOR dem Laubaustrieb, damit Blätter den Windtransport nicht behindern.   * Pollen & Narben: Gewaltige Mengen an winzigem, extrem leichtem, trockenem Flugpollen; weit aus der Blüte herausragende, buschig **gefiederte Fangnarben** zum 'Kämmen' des Windes."
        }
      ]
    },
    {
      "id": "01K4B5P0000000000000000A04",
      "atom_uri": "urn:zam:atom:01K4B5P0000000000000000A04",
      "namespace": "biologie-botanik",
      "slug": "fruchtbildung-samen-verbreitungsmechanismen",
      "title": "Von der Blüte zur Frucht: Fruchtwand, Samenaufbau und die 4 Ausbreitungsmechanismen",
      "domain": "schule/biologie/botanik",
      "reduction": "formal",
      "typical_age_min": 10.5,
      "prerequisites": [
        {
          "atom_id": "01K4B5P0000000000000000A03",
          "type": "hard",
          "rationale": "Erst die Befruchtung der Samenanlage leitet die Fruchtbildung ein."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q10811",
          "target_label": "Seed dispersal",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 5,
          "track": "I",
          "subject": "natur_und_technik",
          "topic_code": "lb3",
          "topic_title": "Blütenpflanzen und Lebensräume",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 5,
          "track": "II_III",
          "subject": "natur_und_technik",
          "topic_code": "lb3",
          "topic_title": "Blütenpflanzen und Lebensräume",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4B5P0000000000000000J07",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Aus welchem Teil der Blüte entwickelt sich nach der Befruchtung die schützende und nährende Fruchtwand (Fruchtfleisch)?",
          "concept": "Aus der Wand des Fruchtknotens (während die Samenanlage zum Samen wird)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Aus der Fruchtknotenwand",
              "Aus den Kronblättern"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4B5P0000000000000000J08",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre die Entstehung von Samen (aus der befruchteten Samenanlage: Samenschale, Keimling/Embryo mit Keimblättern, Nährgewebe) und Frucht (aus dem heranwachsenden Fruchtknoten) und analysiere die 4 evolutionären Strategien der Samenverbreitung: 1. Windausbreitung (Fallschirme wie Löwenzahn, Flügelfrüchte wie Ahorn), 2. Tierausbreitung (Klettfrüchte an Tierfellen wie Klette; Verzehr und Ausscheidung saftiger Beeren/Früchte wie Kirsche durch Vögel; Versteckausbreitung durch Eichhörnchen/Eichelhäher), 3. Wasserausbreitung (Schwimmgewebe wie Kokosnuss, Seerose), 4. Selbstausbreitung / Schleudermechanismen (Springkraut, Spritzgurke).",
          "concept": "Fruchtknoten -> Frucht; Samenanlage -> Samen mit Keimling und Nährvorrat; 4 Verbreitungsarten: Wind (Anemochorie: Schirmchen, Flügel), Tiere (Zoochorie: Kletten, Verdauungsverbreitung, Versteckhorten), Wasser (Hydrochorie), Eigenschleudern (Autochorie: Turgordruck lässt Kapsel platzen).",
          "sample_solution": "1. Umwandlung von Blüte zu Same und Frucht: - Nach der Befruchtung welken Kron-, Kelch- und Staubblätter ab. - Aus der **befruchteten Samenanlage** entsteht der **Samen**:   * **Samenschale (Testa)**: Robuste Schutzhülle gegen Austrocknung und Kälte.   * **Keimling (Embryo)**: Besteht aus Keimwurzel, Keimstängel und 1 oder 2 Keimblättern (Kotyledonen).   * **Nährgewebe (Endosperm)**: Speichert Fette, Stärke und Eiweiße für den Keimvorgang. - Aus der **Wand des Fruchtknotens** entsteht die **Frucht (Fruchtwand / Perikarp)**, die den Samen umschließt. 2. Die 4 Ausbreitungsstrategien von Samen und Früchten: - **1. Windausbreitung (Anemochorie)**:   * Schirmchenflieger: Haarkronen wirken wie Fallschirme (z. B. Löwenzahn, Distel).   * Schraubenflieger / Flügelfrüchte: Drehflügel segeln im Wind weit weg vom Mutterbaum (z. B. Ahorn, Esche, Linde).   * Staubflieger: Winzige, federleichte Samen (z. B. Orchideen, Mohn im Windstreuer). - **2. Tierausbreitung (Zoochorie)**:   * *Klettausbreitung (Epizoochorie)*: Früchte mit Hakenkletten verfangen sich im Fell von Wildtieren oder an Hosenbeinen (z. B. Klette, Klettenlabkraut).   * *Verdauungsausbreitung (Endozoochorie)*: Tiere fressen schmackhaftes, buntes Fruchtfleisch; die harten Samen passieren unbeschadet den Magen-Darm-Trakt und werden mit Kot (Dünger!) weit entfernt ausgeschieden (z. B. Kirsche, Vogelbeere, Himbeere).   * *Versteckausbreitung*: Eichhörnchen und Eichelhäher vergraben Nüsse/Eicheln als Wintervorrat; vergessene Samen keimen im Frühjahr. - **3. Wasserausbreitung (Hydrochorie)**:   * Samen besitzen lufthaltiges Schwimmgewebe oder wasserdichte Schalen (z. B. Kokosnuss, Wasserlilie, Erle). - **4. Selbstausbreitung / Schleudermechanismen (Autochorie)**:   * Reife Fruchtkapseln bauen durch Austrocknungsspannung oder Saftdruck (Turgordruck) extremen Druck auf und explodieren bei Berührung, wodurch die Samen meterweit weggeschleudert werden (z. B. Springkraut, Wiesen-Storchschnabel)."
        }
      ]
    }
  ]
}
